import type { Payment } from '@/types';
import api from './api';

export const paymentService = {
  async getMyPayments(): Promise<Payment[]> {
    const response = await api.get<Payment[]>('/payments/my-payments');
    return response.data;
  },
};

export default paymentService;
